// @ts-no-check Check for typing
/** Avoid running the same function twice within the specified timeframe. */
export const debounce = (func: () => void, wait: number, immediate: boolean = false) => {
    let timeout: NodeJS.Timeout;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (...args: any) {
        // @ts-expect-error Check for typing
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            // @ts-expect-error Check for typing
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        }, wait);
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        if (immediate && !timeout) {
            func.apply(context, args);
        }
    };
};
